/**
 * ResetPassword.tsx - Password Reset Completion View
 *
 * Form for setting new password after clicking reset link from email.
 */

import { Card, Heading, IconButton, Text, VStack } from "@chakra-ui/react";
import { useApi } from "core";
import { useEffect, useState } from "react";

import { useLoading } from '@/hooks/useLoading';
import { t } from "i18next";
import { PasswordInput } from "@/ui/components/ui/password-input";

const CONTAINS_NUMBER = /[\d]+/

export const isValidPassword = (password: string) => {
    if (password === undefined || password === null || password.length < 8) {
        return 'validation_error.password_too_short'
    }
    if (!CONTAINS_NUMBER.test(password)) {
        return 'validation_error.password_must_include_digits'
    }
}

export const ResetPassword: React.FC<any> = ({ }) => {


    const api = useApi()
    const [password, setPassword] = useState<string>('')
    const [confirmPassword, setConfirmPassword] = useState<string>('')
    const [validPasswordError, setValidPasswordError] = useState<string>('')
    const [passwordsDoNotMatchError, setPasswordsDoNotMatchError] = useState<string>('')

    const href = location.href
    const parts = href.split("#")
    const parts_arguments = parts[2].split("&")
    const email = parts_arguments[0]
    const token = parts_arguments[1].replace("token=", "")

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setPassword(value)
        setValidPasswordError(isValidPassword(value))
    }

    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setConfirmPassword(value)
    }

    useEffect(() => {
        if (password !== confirmPassword) {
            setPasswordsDoNotMatchError('validation_error.passwords_must_match')
        } else {
            setPasswordsDoNotMatchError('')
        }
    }, [password, confirmPassword])

    const thereAreErrors = !password || !confirmPassword || validPasswordError || passwordsDoNotMatchError

    const { onClick: handleSubmit, loading } = useLoading(async () => {

        await api.loginWithJwt(token)
        await api.resetPassword({ password })
    })

    return (
        <Card.Root className="fade" margin="auto" maxWidth="fit-content" variant="subtle">
            <Card.Body>
                <VStack>
                    <Heading>{t("reset_your_password")}</Heading>

                    <Text fontStyle="italic">Email: {email}</Text>
                    <PasswordInput type="password" size="lg" variant="flushed" width="30rem" onChange={handlePasswordChange} onKeyDown={e => { if (e.key === 'Enter') { handleSubmit() } }} value={password} placeholder={t("insert_password")} />
                    <PasswordInput type="password" size="lg" variant="flushed" width="30rem" onChange={handleConfirmPasswordChange} onKeyDown={e => { if (e.key === 'Enter') { handleSubmit() } }} value={confirmPassword} placeholder={t("confirm_password")} />
                    <IconButton width="30rem" colorPalette="red" variant="solid" marginTop={4} onClick={handleSubmit}>{t("reset_password")}</IconButton>

                </VStack>

            </Card.Body>
        </Card.Root >
    )
}
